/*
 * This model holds the data for course-plan-builder api access page of the calcualtor
 *
 */
import httpClient from 'client/js/models/http-client'

class CoursePlanBuilder {
   static async validateCoursePlan(plan) {
      try {
         let response = await httpClient.post(BaseURL + "/api/course-plan-builder/validate/", { data: plan })
         return response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response) {
            console.log('Builder Validation Error', response.data.response)
            throw new Error(response.data.response)
         }
         throw (err)
      };
   }
   static async generateCoursePlan(plan, summary) {
      try {
         let response = await httpClient.post(BaseURL + "/api/course-plan-builder/generate/", { data: plan, summary })
         return response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response) {
            console.log('Builder Generation Error', response.data.response)
            err = new Error('Builder Generation Error')
            // Keep response data as error properties
            Object.assign(err, response.data)
         }
         throw (err)
      };
   }
}

module.exports = CoursePlanBuilder
